import { GameVars } from "../../GameVars";
import { GameConstants } from "../../GameConstants";
import { ShopLid } from "./ShopLid";
import { PaginationButton } from "./PaginationButton";
import { ItemsContainer } from "./ItemsContainer";
import { AudioManager } from "../../AudioManager";
import { BootScene } from "../BootScene";

export class ShopContainer extends Phaser.GameObjects.Container {

    private boardsLid: ShopLid;
    private strikersLid: ShopLid;
    private activeLid: string;
    private leftPaginationButton: PaginationButton;
    private rightPaginationButton: PaginationButton;
    private boardsContainer: ItemsContainer;
    private strikersContainer: ItemsContainer;

    constructor(scene: Phaser.Scene) {

        super(scene);

        this.x = GameConstants.GAME_WIDTH / 2;
        this.y = 175 * GameVars.scaleY;

        this.scaleY = GameVars.scaleY;

        this.activeLid = ShopItem.BOARD;

        const gameText = this.scene.game.cache.json.get("game-text");

        const titleLabel = new Phaser.GameObjects.Text(this.scene, 0, 0 + (BootScene.textYgap * -70), gameText.SHOP, { fontFamily: "Teko-Medium", fontSize: "70px", color: "#FFFFFF" });
        titleLabel.setOrigin(.5,BootScene.originY);
        titleLabel.setShadow(0, 6, "#061f55", 0, false, true);
        this.add(titleLabel);

        this.boardsLid = new ShopLid(this.scene, ShopItem.BOARD, this);
        this.boardsLid.x = -156;
        this.boardsLid.y = 82;
        this.add(this.boardsLid);

        this.boardsLid.activate();

        this.strikersLid = new ShopLid(this.scene, ShopItem.STRIKER, this);
        this.strikersLid.x = 140;
        this.strikersLid.y = 82;
        this.strikersLid.deactivate();
        this.add(this.strikersLid);

        const background = new Phaser.GameObjects.Graphics(this.scene);
        background.fillStyle(0x87CFFF, .1);
        background.fillRoundedRect(-GameConstants.GAME_WIDTH * .45, 120, GameConstants.GAME_WIDTH * .9, 1200, 20);
        this.add(background);

        const backgroundFrame = new Phaser.GameObjects.Graphics(this.scene);
        backgroundFrame.lineStyle(5, 0x133770);
        backgroundFrame.strokeRoundedRect(-GameConstants.GAME_WIDTH * .45, 120, GameConstants.GAME_WIDTH * .9, 1200, 20);
        this.add(backgroundFrame);

        this.boardsContainer = new ItemsContainer(this.scene, ShopItem.BOARD);
        this.add(this.boardsContainer);

        this.strikersContainer = new ItemsContainer(this.scene, ShopItem.STRIKER);
        this.add(this.strikersContainer);

        this.strikersContainer.visible = false;

        this.leftPaginationButton = new PaginationButton(this.scene, PaginationButton.LEFT, this);
        this.leftPaginationButton.x = -280;
        this.leftPaginationButton.y = -this.y + (GameConstants.GAME_HEIGHT - 190) / GameVars.scaleY;
        this.add(this.leftPaginationButton);

        this.rightPaginationButton = new PaginationButton(this.scene, PaginationButton.RIGHT, this);
        this.rightPaginationButton.x = 280;
        this.rightPaginationButton.y = -this.y + (GameConstants.GAME_HEIGHT - 190) / GameVars.scaleY;
        this.add(this.rightPaginationButton);

        this.leftPaginationButton.deactivate();
        this.rightPaginationButton.activate();
    }

    public onClickLid(lidType: string): void {

        AudioManager.playSound("click_btn");

        if (lidType !== this.activeLid) {

            if (lidType === ShopItem.BOARD) {

                this.boardsLid.activate();
                this.strikersLid.deactivate();

                this.boardsContainer.visible = true;
                this.strikersContainer.visible = false;

                this.setPaginationButtons(this.boardsContainer.currentPage, this.boardsContainer.totalPages);

            } else {

                this.boardsLid.deactivate();
                this.strikersLid.activate();

                this.boardsContainer.visible = false;
                this.strikersContainer.visible = true;

                this.setPaginationButtons(this.strikersContainer.currentPage, this.strikersContainer.totalPages);
            }

            this.activeLid = lidType;
        }
    }

    public onClickPaginationButton(side: string): void {

        AudioManager.playSound("click_btn");

        let itemsContainer: ItemsContainer;

        if (this.activeLid === ShopItem.BOARD) {
            itemsContainer = this.boardsContainer;
        } else {
            itemsContainer = this.strikersContainer;
        }

        itemsContainer.scroll(side);

        this.setPaginationButtons(itemsContainer.currentPage, itemsContainer.totalPages);
    }

    public updateItems(): void {

        this.boardsContainer.updateItems();
        this.strikersContainer.updateItems();
    }

    private setPaginationButtons(currentPage: number, totalPages: number): void {

        if (currentPage > 1 && currentPage < totalPages) {
            this.leftPaginationButton.activate();
            this.rightPaginationButton.activate();
        } else if (currentPage === 1) {
            this.leftPaginationButton.deactivate();
            this.rightPaginationButton.activate();
        } else {
            this.leftPaginationButton.activate();
            this.rightPaginationButton.deactivate();
        }
    }
}
